import { useAppSelector } from "store"

import { photoPreviewDuplicateSelectors } from "./photoPreviewDuplicateSlice"

export const getPhotoPreviewDuplicateItemsSelector = () => useAppSelector(state => photoPreviewDuplicateSelectors.selectAll(state.photoPreviewDuplicate))

export const getPhotoPreviewDuplicateStatusLoadingSelector = () => useAppSelector(state => state.photoPreviewDuplicate.status)

export const getPhotoPreviewDuplicateModeSelector = () => useAppSelector(state => state.photoPreviewDuplicate.duplicateMode)
